import React from "react";
import { bool, func, node, number, oneOfType, shape, string } from "prop-types";

import { BaseTabWrapper, TabEnum } from "../styled";

const ToggleItem = props => {
  const { item, onClick, theme } = props;
  const { disabled, value } = item;

  const handleClick = event => {
    const tabData = { value };
    onClick({ event, tabData });
  };

  const ToggleTheme = TabEnum[theme] || BaseTabWrapper;

  return (
    <ToggleTheme
      {...props}
      disabled={disabled}
      onClick={handleClick}
      value={value}
    >
      {item.text && item.text} {item.subtext && item.subtext}
    </ToggleTheme>
  );
};

ToggleItem.propTypes = {
  active: bool,
  item: shape({
    text: oneOfType([string, node]),
    subtext: oneOfType([string, node]),
    value: oneOfType([bool, number, string]),
    disabled: bool
  }),
  onClick: func,
  theme: string
};

ToggleItem.defaultProps = {
  active: false,
  item: { disabled: false },
  onClick: () => {},
  theme: ""
};

export default ToggleItem;
